<template>
  <div class="details">
    <div class="header">
      您的位置:
      <router-link class="link" to="/mall">积分商城</router-link>> 礼品兑换
    </div>

    <div class="GoodsDetails">
      <div class="goodsDetails">
        <mirror style="flex: 1" :width="width" :picList="picList" />
        <div style="flex: 2">
          <div style="margin-left: 2rem; margin-top: 30px">
            <p style="font-size: 1.2rem; color: #555">
              商品名称: <i style="color: #f00">{{ detailsList.GoodsName }}</i>
            </p>
            <div
              style="
                background-color: #fff7ed;
                color: #333;
                margin-top: 1rem;
                padding-left: 10px;
                border-radius: 5px;
                width: 70%;
                height: 250px;
              "
            >
              <p style="color: #999">
                兑换规则:用户按照发布的分值兑换商品，点击兑换按钮需要用户填写收货信息,请您仔细填写收货信息！
              </p>
              <p>
                所需积分:
                <i style="color: #ff9900">{{ detailsList.NeedIntegral }}积分</i>
              </p>
              <p>支付方式: <i>积分</i></p>
            </div>
            <el-button class="btn" @click="dialogVisible = true" type="success"
              >立即兑换</el-button
            >
          </div>
        </div>
      </div>
      <div style="width: 50%;margin:auto">
        <div v-html="detailsList.Details"></div>
      </div>
    </div>
    <el-dialog
      title="商品兑换"
      :visible.sync="dialogVisible"
      center
      width="40%"
      :before-close="handleClose"
    >
      <div>
        <div style="margin-bottom: 1rem; border-bottom: 1px solid #999">
          <el-form ref="form" label-width="80px">
            <el-form-item label="选择地址:">
              <el-select
                style="width: 80%"
                @change="addressChange"
                v-model="addressValue"
                placeholder="请选择活动区域"
              >
                <el-option
                  v-for="(item, index) in addressList"
                  :key="index"
                  :label="
                    item.Name +
                    '—' +
                    item.Phone +
                    ':' +
                    item.Province +
                    '-' +
                    item.City +
                    '-' +
                    item.Area +
                    '-' +
                    item.Detail
                  "
                  :value="item.Id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div>
          <div class="flexBox">
            <div style="width:30%">
              <img style="width: 100px" :src="picList[0]" alt="" />
            </div>
            <div style="width:70%">
              <div>
                <div  style="margin-top:1rem">{{ detailsList.GoodsName }}</div>
                <div  style="margin-top:1rem">
                  <i style="color: #f00">{{ detailsList.NeedIntegral }}积分</i>
                </div>
              </div>
              <div style="margin-top:1rem">
                <el-input-number
                  v-model="num"
                  size="mini"
                  :min="1"
                  :max="10"
                  label="描述文字"
                ></el-input-number>
              </div>
            </div>
          </div>
          <div style="margin-top:1rem">
             <el-input type="textarea" resize="none"  placeholder="请输入订单需要备注内容" :rows="3" v-model="note"></el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="ExchangeMall"
          >确定兑换</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getMall } from "../../api/http/mall";
import {getOrderApi} from "../../api/http/order"
import { address } from "../../api/http/address";
import mirror from "../../components/amplification/amplification.vue";
export default {
  components: {
    mirror,
  },
  data() {
    return {
      note:'',//订单备注
      num: 0, //数量
      dialogVisible: false, //对话框显示
      addressValue: "", //选择这地址显示
      addressId: 0, //地址id
      width: 400,
      picList: [],
      Id: "", //订单id
      detailsList: [], //详情数组
      addressList: [], //地址数组
    };
  },
  created() {
    this.picList = [];
    this.Id = this.$route.query.Id;
    this.getDetail(); //订单详情
    this.getAddress(); //地址数组
  },
  methods: {
    addressChange(el) {
      this.addressId = el;
    },
    // 获取去地址数组
    getAddress() {
      let params = {
        page: 1,
        size: 30,
      };
      address.addressList(params).then((res) => {
        this.addressList = res.data.data;
        for (let i = 0; i < this.addressList.length; i++) {
          if (this.addressList[i].IsDefault) {
            this.addressValue =
              this.addressList[i].Name +
              "—" +
              this.addressList[i].Phone +
              ":" +
              this.addressList[i].Province +
              "-" +
              this.addressList[i].City +
              "-" +
              this.addressList[i].Area +
              "-" +
              this.addressList[i].Detail;
            this.addressId = this.addressList[i].Id;
          }
        }
      });
    },
    // 积分详情
    getDetail() {
      getMall.getDetails({ id: this.Id }).then((res) => {
        this.detailsList = res.data.data;
        this.picList.push(res.data.data.ImgDtos[0].ImgUrl);
      });
    },
    // 关闭对话框
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    // 兑换商品
    ExchangeMall() {
      let json={
        goodsId:this.Id,
        quantity:this.num
      }
      let goodsInfos=[]
      goodsInfos.push(json)
      let params={
        addressId:this.addressId,//收货地址
        amount:this.detailsList.NeedIntegral*this.num,//积分量
        goodsInfos,
        orderType:1,
        remark:this.note
      }
      getOrderApi.setSubmit(params).then(res=>{
        if(res.data.code==200){
          this.dialogVisible=false
          this.$message({
            messaage:"兑换成功!",
            type:'success'
          })
        }else{
          this.$message({
            message:res.data.msg,
            type:'error'
          })
        }
        console.log(res)
      })
      console.log(params)
    },
  },
};
</script>
<style lang="scss" scoped>
.flexBox{
  display: flex;
}
.details {
  width: 70vw;
  margin: auto;
  .header {
    font-size: 1.2rem;
    display: flex;
    color: #999;
    .link {
      color: #999;
    }
    .link:hover {
      color: #f00;
    }
  }
  .goodsDetails {
    width: 70vw;
    display: flex;
    margin-top: 2rem;
    div {
      p {
        line-height: 2rem;
      }
    }
  }
  .btn {
    background: #ff9900;
    border: none;
    z-index: 0;
    font-size: 1.2rem;
    margin: 2rem 0 0 1rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/mall/details.vue